{"browse_shop":"Explorar tienda","go_to_shop":"Ir a la tienda","no_orders_found":"No se encontraron pedidos","title":"Pedidos"}